export default "__VITE_ASSET__BLveqncD__"